import React from "react";

export default function PartnersSection() {
  return (
    <section className="text-center mb-16 px-4">
      <h2 className="text-3xl font-extrabold mb-6"> Our Partners</h2>
      <div className="flex justify-center">
        <div className="relative group inline-flex flex-col items-center">
          {/* Logo */}

          <a
            href="https://www.okapion.com"
            target="_blank"
            rel="noreferrer"
            className="inline-flex flex-col items-center transition-transform duration-300 hover:scale-105"
          >
            <img
              src="/okapion.png"
              alt="Okapion"
              className="h-20 sm:h-24 w-auto object-contain transition-transform duration-300 group-hover:scale-105 drop-shadow-md"
            />
          </a>
          {/* Hover Text (gray transparent background) */}
          <div className="absolute bottom-full mb-4 w-80 sm:w-96 bg-gray-800/85 border border-white/20 rounded-lg p-4 text-sm text-white text-center shadow-xl z-50 hidden group-hover:block backdrop-blur-sm">
            <p className="mb-3 leading-relaxed">
              Okapion wants to contribute to an app that supports, inspires, and
              challenges athletes. Our strength lies in understanding user
              behavior and translating it into a design that feels intuitive,
              motivates, and builds trust with every interaction.
            </p>
            <a
              href="https://www.okapion.com"
              target="_blank"
              rel="noreferrer"
              className="underline text-teal-300 hover:text-teal-200"
            >
              www.okapion.com
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
